var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "calendar-container" }, [
      _c(
        "div",
        {
          class: {
            "fix-width": true,
            "d-none": _vm.currentViewedEvent === null,
            "sticky-stick": _vm.isSticky
          },
          attrs: { id: "event-popup" }
        },
        [
          _c(
            "button",
            {
              staticClass: "close-popup d-block d-md-none",
              on: {
                click: function($event) {
                  return _vm.resetPopup()
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          ),
          _vm._v(" "),
          _c("grid-item", {
            staticClass: "fix-width",
            attrs: {
              displayType: "grid",
              dataLoading: _vm.isDataLoading,
              item: _vm.getPopupMpe,
              variant: _vm.campaignPreviewItems ? "basic" : "detailed"
            },
            on: {
              editMpe: _vm.editMpe,
              removeMpe: _vm.removeMpe,
              duplicate: _vm.duplicate
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "f_calendar" } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-440cfeed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440cfeed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/CampaignCalendar.vue
// module id = null
// module chunks = 